<template>

  <!-- ========================= SECTION CONTENT ========================= -->
  <section class="" style="min-height:99vh">
  
          <Loader
        :isLoading='isLoading'
        />  


        
    <div class="container"  >

        <CenteredFigure
        Img='https://appcar-app.s3.amazonaws.com/static/logo/logo-apr-191x208.png'
        />

      <form class='login' >
        <InputRedLight
            v-mask="['##########', '###########']"
            autoComplete="off"
            placeholder='Número de celular'
            id="phone"
            type="tel"
            minLength=11
            maxLength=20
            title="digite seu celular"
            v-model.trim="form.username"

        />

        <InputRedLight
            autoComplete="off"
            placeholder='Senha'
            id="password"
            type="password"
            minLength=6
            maxLength=20
            title="digite sua senha"
            v-model='form.password' 

        />



        <div class='mt-5'></div>

        <Button
        id='login_button'
        Type='submit'
        Text='LOGIN'
        :ButtonFunction='submit'
        />

        
        <ButtonRegister
        id='regiter_button'
        Type='button'
        Text='CADASTRAR'
        class='mt-3'
        :ButtonFunction='register'
        />
        
        



    </form>

   

        </div>


  </section>
  <!-- ========================= SECTION CONTENT END// ========================= -->


 
</template>

<script>
import Loader from '@/components/Load/LoadOverlay'
import CenteredFigure from '../../../components/ImageStyle/CenteredFigure'
import InputRedLight from '../../../components/Input/InputRedLight'
import Button from '../../../components/Button/ButtonCallToAction'
import ButtonRegister from '../../../components/Button/ButtonCallToActionOutline'

import { mapActions } from 'vuex'


export default {
  data: () => ({
    form: {
      username: '',
      password: ''
    },
    regiter:{
      nome:'',
      email:'',
      celular:'',
      password:'',
      passwordConfirm:''
    },
    isLoading:undefined,
    registerMode:false
  }),
  components: {
    Loader,
    CenteredFigure,
    InputRedLight,
    Button,
    ButtonRegister,
  },
  async created () {
    console.log('created');
     if (this.$route.query.tk) {
          console.log('TK')
          this.haveToken = !this.haveToken
          this.Loading = !this.Loading
          const token = this.$route.query.tk
          await this.ActionLoadSession(token)
          this.Loading = !this.Loading
          this.$router.push({ name: 'home'})
          
          
      }
  },
  methods: {
    ...mapActions('auth', ['ActionDoLogin','ActionLoadSession']),
    async submit () {
      const login_button = document.getElementById("span-button")
                login_button.classList.add('spinner-border')
                login_button.classList.add('spinner-border-sm')
      try {
        const payload = {
          username: this.form.username,
          password: this.form.password
        }
        this.isLoading = !this.isLoading
        await this.ActionDoLogin(payload)
        this.isLoading = !this.isLoading
        this.$router.push({ name: 'home' })
      } catch (err) {
        this.isLoading = !this.isLoading
        const login_button = document.getElementById("span-button")
        login_button.classList.remove('spinner-border')
        login_button.classList.remove('spinner-border-sm')
        alert(err.body['non_field_errors'][0])
        this.$router.push({ name: 'login' })
      }
    },
    register(){
      this.$router.push({ name: 'register' })
    },
    goRegister(){
      alert('register')
    }
  }
}
</script>

<style>
.btn-red {
    color: #fff;
    background-color: var(--main-red);
    border-color:var(--main-red-black);
}

.btn-red :hover {
  color:var(--main-red-black);
}

  .login{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
}

  @media (min-width: 1000px) and (max-width: 2600px) {
  .login{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }


</style>
